const breadCrumb = "Lançamento de Notas - Lançamento de Notas/Conceitos/Faltas";

const routes = [
  {
    path: "/consultar-resumo-de-lancamento-de-notas-conceitos/:id/:periodoId/turmas-nao-iniciadas",
    name: "consultar-resumo-de-lancamento-de-notas-conceitos-turmas-nao-iniciadas",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ConsultarResumoDeLancamentoDeNotasConceitos/ConsultarResumoDeLancamentoDeNotasConceitosTurmasNaoIniciadas.vue"
      ),
  },
  {
    path: "/consultar-resumo-de-lancamento-de-notas-conceitos/:id/turmas-nao-iniciadas/:turmaId",
    name: "consultar-resumo-de-lancamento-de-notas-conceitos-turmas-nao-iniciadas-detalhe",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ConsultarResumoDeLancamentoDeNotasConceitos/TurmasNaoIniciadas/DisciplinaAreaDoConhecimento.vue"
      ),
  },
  {
    path: "/consultar-resumo-de-lancamento-de-notas-conceitos/:id/turmas-nao-iniciadas/:turmaId/alunos-sem-nota-zero/:resumoId",
    name: "consultar-resumo-de-lancamento-de-notas-conceitos-turmas-nao-iniciadas-alunos-sem-nota-zero",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ConsultarResumoDeLancamentoDeNotasConceitos/TurmasIniciadas/AlunosSemNotaZero.vue"
      ),
  },
  {
    path: "/consultar-resumo-de-lancamento-de-notas-conceitos/:id/turmas-nao-iniciadas/:turmaId/alunos-com-nota-zero/:resumoId",
    name: "consultar-resumo-de-lancamento-de-notas-conceitos-turmas-nao-iniciadas-alunos-com-nota-zero",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ConsultarResumoDeLancamentoDeNotasConceitos/TurmasIniciadas/AlunosComNotaZero.vue"
      ),
  },
];

export default routes;
